/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { generateSimplestList, simpleLocalAttribute } from '@touchplan/common';
import { DefaultSplitDataRenderType, SplitData, UserSignUpMethod } from '@touchplan/common';

export interface InvitedUserFields {
	company?: string;
	email: string;
	accessLevel: string;
	roleId: string;
	color?: string;
	secondaryRoles?: string[];
	method?: UserSignUpMethod.Invite; //seems... un-necessary
}

export class InvitedUser extends SplitData<InvitedUserFields, DefaultSplitDataRenderType> {
	protected useInPlace = true;
	protected attributeList = Object.assign(
		generateSimplestList(['company', 'email', 'accessLevel', 'roleId', 'secondaryRoles', 'method']),
		{
			color: simpleLocalAttribute,
		}
	);

	constructor(id: string) {
		super(id, DefaultSplitDataRenderType.database);
	}
}
